module.exports = "<section class=\"tags\">\n    <div class=\"tag\" ng-repeat=\"tag in tagListView.tags\">\n        <i class=\"icon material-icons pointer pull-left\" ng-click=\"tagListView.removeTag(tag.id)\" ng-if=\"tag.canBeRemoved\">&#xE14C;</i>\n        <div class=\"tooltip pull-right\">\n            <i class=\"icon material-icons pointer\">&#xE88E;</i>\n            <div class=\"tooltip-text right\">{{tag.reason}}</div>\n        </div>\n        {{tag.title}}\n    </div>\n\n    <a class=\"bttn full-width\" href=\"\" ng-click=\"tagListView.addFlag()\">Add Flag / Tag</a>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./Client/app/tasks/tags/tag-list.html
// module id = 617
// module chunks = 0